module.exports = __webpack_public_path__ + "img/spinner-gradient.9371bdbd.svg";